// ======================================================================
// File Name       : AccountEditContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import * as accountActions from '../../actions/AccountAction';
import DialogConfirm from '../../components/DialogConfirm';
import Header from '../../components/Header';
import AccountForm from '../../components/account/AccountForm';
import { SUPERUSER_LOGIN_TYPE } from '../../constants/CommonConstants';
import * as Messages from '../../constants/MessageTemplate';
import { PASS_STRENGTH_TYPE } from '../../constants/index';
import * as SessionStorageUtils from '../../utils/SessionStorageUtils';

class AccountEditContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      showModal: false,
      userInfo: {
        userSecernId: null,
        loginId: '',
        currentPassword: '', // Step11.0.0
        password: '',
        userName: '',
        passwordConfirm: '',
        passStrType: PASS_STRENGTH_TYPE.STRONG,
        mailAddress: '', // Step10.0.0
      },
      integrationUserInfo: {}
    };

    this.handleShowConfirm = this.handleShowConfirm.bind(this);
    this.saveAccount = this.saveAccount.bind(this);
    this.handleChangeInfo = this.handleChangeInfo.bind(this);
    this.handleCancelConfirm = this.handleCancelConfirm.bind(this);
  }

  componentWillMount() {
    const { authedUser, service, integrationUser } = this.props;
    const { userInfo } = authedUser;
    const userInfoFromState = { ...this.state.userInfo };
    // because LO_SupperUser, Supper User and Admin can access this page.
    userInfo.passStrType = PASS_STRENGTH_TYPE.STRONG;
    if (!userInfo.loginId) {
      userInfo.loginId = SessionStorageUtils.getByKey('loginId');
    }
    // STEP 12.0.0 START
    if (integrationUser && Object.keys(integrationUser).length) {
      userInfo.userSecernId = integrationUser.superuserSecernId;
      userInfo.userName = integrationUser.superuserName;
      userInfo.loginId = integrationUser.loginId;
      userInfo.mailAddress = integrationUser.mailAddress;
      userInfo.lastLoginTime = integrationUser.lastLoginTime;
    }
    // STEP 12.0.0 END
    this.setState({
      userInfo,
    });
  }

  handleShowConfirm() {
    let isValid = true;
    isValid = Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
    if (isValid) {
      this.setState({
        showModal: true,
      });
    }
  }

  /**
     * handle change for user input
     * @param {*} event
     */
  handleChangeInfo(event) {
    const { name, value } = event.target;
    const userInfo = {
      ...this.state.userInfo,
      ...{ [name]: value },
    };
    this.setState({ userInfo });
  }

  saveAccount() {
    const { dispatch } = this.props;
    // Step10.0.0 START
    const { userName, loginId, currentPassword, password, mailAddress } = this.state.userInfo;
    dispatch(accountActions.saveAccount({ userName, loginId, currentPassword, password, mailAddress }));
    // Step10.0.0 END
    this.setState({
      showModal: false,
    });
  }

  /**
   * Handle on Cancel click
   */
  handleCancelConfirm() {
    this.setState({ showModal: false });
  }

  render() {
    const { userInfo } = this.state;
    const { integrationUser } = this.props;
    this.refsToValidate = [];
    return (
      <div>
        <Header name="アカウント情報の編集"/>
        <h2>アカウント情報を入力してください</h2>
        <AccountForm
          userInfo={userInfo || {}}
          handleChangeInfo={this.handleChangeInfo}
          handleShowConfirm={this.handleShowConfirm}
          ref={(ref) => {
            if (ref) {
              this.refsToValidate.push(ref);
            }
          }}
          // Step12.0.0 TAS-19966 START
          isIntegrationUserEdit={
            (integrationUser && Object.keys(integrationUser).length) ||
            userInfo.superuserType ===
              SUPERUSER_LOGIN_TYPE.INTEGRATION_ROOT_SUPERUSER
          }
          // Step12.0.0 TAS-19966 END
        />
        <DialogConfirm
          showModal={this.state.showModal}
          onCancel={this.handleCancelConfirm}
          content={Messages.ACCOUNT_CHANGE_CONFIRM}
          onOK={this.saveAccount}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { authed, user: { integrationUser } } = state;
  const { authedUser } = authed;
  return {
    authedUser,
    integrationUser,
  };
};
export default connect(mapStateToProps)(AccountEditContainer);
